/* eslint new-cap: [2, {"capIsNewExceptions":["Map"]}] */
import appJs from 'appJs';
import * as types from '../constants';
import triggerAction from '../actions';

datacenterSheet.$inject = ['$q', '$location', '$ngRedux', 'Loader'];
export default function datacenterSheet(
  $q,
  $location,
  $ngRedux,
  Loader) {
  this.$ngRedux = $ngRedux;
  this.$location = $location;
  this.$q = $q;
  this.Loader = Loader;
}

/**
 * Async Loader callback where you can customize the sheet request for cache
 * bypass, local json, etc.
 *
 * @param {object} appJs The javascript config object from post-indicator.php
 *
 * @return {promise} A promise object for the indicator data
 */
datacenterSheet.prototype.loadDataFromSource = function(options = appJs) {
  const noCache = this.$location.search().noCache || options.is_preview;

  this.Loader.URL = window.location.origin
    + '/wp-json/kff/v1/google-sheets-full?id='
    + (options.gdocs_key || options.gdocsKey);
  if (noCache) {
    this.Loader.URL += '&noCache=true';
  }
  return this.$q.when(this.Loader.get());
};

/**
 * An async action creator which bootstraps the spreadsheet data for this
 * indicator
 *
 * @return {function} A redux async action
 */
datacenterSheet.prototype.buildSheetData = function() {
  this.$ngRedux.dispatch(triggerAction(types.LOADING_DATA));
  return (dispatch, getState) => {
    const state = getState();
    // Only fetch if data has not already been filled
    if (state.data.immutableData) {
      return;
    }
    // This should prevent double requests
    if (appJs.gdocsObject && !appJs.is_preview) {
      dispatch(triggerAction(types.BUILD_DATA, {
        data: appJs.gdocsObject,
        options: state.router.currentParams,
      }));
      return;
    }
    // Removing this for load issues for the time being
    this.loadDataFromSource()
      .then((data) => {
        dispatch(triggerAction(types.BUILD_DATA, {
          data,
          options: state.router.currentParams,
        }));
      });
  };
};



/** WEBPACK FOOTER **
 ** ../~/eslint-loader!./js/services/datacenterSheet.js
 **/